import { createContext } from 'react';
export const PopupContext = createContext({
    isInPopup: false,
    setScrollableContentRef: (node)=>{
    /* noop */ },
    /* DO NOT USE THIS - If you are using ModalLayout */ setDefaultScrollableRef: (node)=>{
    /* noop */ }
});
PopupContext.displayName = 'PopupContext';

//# sourceMappingURL=PopupContext.js.map